import ReportsActivity from "Pages/Dashboard/reports_v2/activity/ReportsActivity";
import ReportsSequence from "Pages/Dashboard/reports_v2/sequence/ReportsSequence";
import React from "react";
import {
  Redirect,
  Route,
  Switch,
  useRouteMatch,
  withRouter
} from "react-router-dom";
import ReportsCalls from "./calls/ReportsCalls";

const ReportsRouting = () => {
  let { path = "" } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={`${path}/activity`} component={ReportsActivity} />
      <Route exact path={`${path}/sequence`} component={ReportsSequence} />
      <Route exact path={`${path}/calls`} component={ReportsCalls} />
      {/* <Route exact path={`${path}/linkedin`} component={ReportsLinkedIn} />
      <Route exact path={`${path}/whatsapp`} component={ReportsWhatsApp} /> */}
      <Redirect from={path} to={`${path}/activity`} />
    </Switch>
  );
};

export default withRouter(ReportsRouting);
